<div class="idle-warning-overlay" *ngIf="showWarning">
  <div class="idle-warning-dialog">
    <h3>Session Timeout Warning</h3>
    <p>
      Your session will expire in <strong>{{ countdown }}</strong> seconds due to inactivity.
    </p>
    <div class="buttons">
      <button class="btn btn-primary" (click)="extendSession()">Stay Logged In</button>
      <button class="btn btn-secondary" (click)="logout()">Logout Now</button>
    </div>
  </div>
</div>
